import React from 'react';
import { Row } from 'antd';
import logo from 'assests/images/logo.png';
import './header-without-auth.less';
import logoWhite from '../../assests/images/logo-white.png';
import { NavLink } from 'react-router-dom';

const HeaderWithoutAuth = ({white}) => (
  <Row className="header" justify="center"><NavLink to="/">
    {white === true ? <img  alt="logo"  className="header-logo" src={logoWhite} /> : <img alt="logo" className="header-logo" src={logo} /> }</NavLink>
  </Row>
);

export default HeaderWithoutAuth;
